import {
  entityMembersFromKeys,
  visibleEntityMemberKeysFromMembers,
} from '@neptune/shared/entity-domain';

import {
  type CompareDataDTOLatest,
  CompareDataDTOLatestInput,
  isCompareDataDTOLatest,
  upgradeToCompareDataDTOLatest,
  wrapAsCompareDataDTOLatest,
} from './compare-data-dto';

export type CompareContent = {
  workspaceName: string;
  projectIdentifier: string;
  compare: {
    runIds: string[];
    experimentNames: string[];
  };
};

export const CompareDataModelConverter = {
  fromDomainToApi(source: CompareContent): CompareDataDTOLatest {
    const runIds = source.compare.runIds.toSorted();
    const experimentNames = source.compare.experimentNames.toSorted();

    return wrapAsCompareDataDTOLatest({
      workspaceName: source.workspaceName,
      projectIdentifier: source.projectIdentifier,
      compare: {
        runMembers: entityMembersFromKeys(runIds),
        experimentMembers: entityMembersFromKeys(experimentNames),
      },
    });
  },

  fromApiToDomain(source: CompareDataDTOLatestInput): CompareContent {
    const latest = isCompareDataDTOLatest(source) ? source : upgradeToCompareDataDTOLatest(source);

    return {
      workspaceName: latest.workspaceName,
      projectIdentifier: latest.projectIdentifier,
      compare: {
        runIds: visibleEntityMemberKeysFromMembers(latest.compare.runMembers),
        experimentNames: visibleEntityMemberKeysFromMembers(latest.compare.experimentMembers),
      },
    };
  },
};
